import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Button, Tooltip, Badge, Input, Label } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import moment from "moment";
import { Link } from 'react-router-dom'

class TableSecondComponent extends Component {
	userdata = JSON.parse(localStorage.getItem('userdata'));
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();

  historyTable = "listhukdisbawahanproccess";
  defaultOrder = "punishment_discipline_id";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };
  modal_confirm_status = 0
  modal_confirm_message = ""
  modal_confirm_sucess_message = "data berhasil diproses"
  modal_confirm_error_message = "data gagal diproses"

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      pemanggilanUuid: null,
      uploadSpUuid: null,
      inactiveUuid: null,
	  detailUuid:null,
	  uploadHasilUuid:null,
	  uploadSkUuid:null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
          filter_value: "",
          page_number: 1,
          page_size: this.defaultSize,
          sort_order: {
            column: this.defaultOrder,

            order: this.defaultSort,
          },
        },
      dataSelected: [],
      checkAll: false,
	  isAtasan: this.userdata?.is_atasan
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.props.uuid,
      employee_uuid: this.props.employeeSeleted,
      work_unit_uuid: this.props.work_unit_uuid,
      is_atasan: 1,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      is_process: 1
    };
    await this.dataTableBloc.fetchRowTableunprocessatasan(query, this.source.token);
  };

  resetTable = () => {
    this.setState({
      dataSelected: []
    })
  }

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status)
        if (data_status === 1) {
          let formData = {
            uuid: this.props.uuid,
            nips: this.state.dataSelected
          }
          this.indexBloc.fetchProcess(formData)
        }else if (data_status === 2) {
          // let formData = {
          //   uuid: this.props.uuid
          // }
          // this.indexBloc.fetchGenerate(formData)
          this.loadData()

        } else {
          this.activeData()
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  handleDownloadDraftSP = (uuid) => {
    this.indexBloc.fetchDownloadSP({
        uuid: uuid
    });
}

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };
  activeData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableUnprocessAtasanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;

          // set state for every checkbox
          for (let i = 0; i < response.result.length; i++) {
            let thisId = response.result[i].no
            this.setState({
              [`check${thisId}`]: false
            })
          }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.processChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:

          if (result.data.status) {
            this.setState({
              loading: false,
              success: true
            }, function () {
              this.setTokenAPI()
              this.resetTable()
              this.props.handleProcessSuccess()
            });
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true
            });
          }

          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    });
    
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
	{
		key: "punishment_discipline_employee_nip",
		text: "NIP",
		className: "punishment_discipline_employee_nip",
		sortable: true,
		width: '130'
	},
	{
		key: "punishment_discipline_employee_name",
		text: "Nama",
		className: "punishment_discipline_employee_name",
		sortable: true
	},
	{
		key: "punishment_discipline_employee_work_unit",
		text: "Unit Kerja",
		className: "punishment_discipline_employee_work_unit",
		sortable: true,
		width: '200'
	},
	{
		key: "punishment_discipline_period_year",
		text: "Tahun",
		className: "punishment_discipline_period_year",
		sortable: true,
		width: '200'
	},
	{
		key: "punishment_discipline_total_day_late",
		text: "Akumulasi Hari",
		className: "punishment_discipline_total_day_late",
		sortable: true,
		width: '200',
		cell : record => {
			return record.punishment_discipline_total_day_late + ' Hari';
		}
	},
	{
		key: "punishment_discipline_punishment_name",
		text: "Rekomendasi Hukuman Disiplin",
		className: "punishment_discipline_punishment_name",
		sortable: true,
		width: '200'
	},
	// {
	// 	key: "punishment_discipline_result_punishment_name",
	// 	text: "Keputusan Hukuman Disiplin",
	// 	className: "punishment_discipline_result_punishment_name",
	// 	sortable: true,
	// 	width: '200'
	// },
	{
		key: "punishment_discipline_result_final_punishment_name",
		text: "Hasil Akhir Hukuman Disiplin",
		className: "punishment_discipline_result_final_punishment_name",
		sortable: true,
		width: '200'
	},
	{
		key: "punishment_discipline_status_name",
		text: "Status",
		className: "punishment_discipline_status_name",
		sortable: true,
		width: '200'
	},
	{
		key: "action",
		text: "Action",
		className: "action",
		width: 120,
		sortable: false,
		align: 'center',
		cell: record => {
			const thisId = record.punishment_discipline_id
			var  status = record.punishment_discipline_status
			return (
				<Fragment>
					{ accessRole('read') &&
						<span>
							<button
								className="btn btn-primary btn-sm"
								id={"detail-" + thisId}
								onClick={() => {
									this.setState({
										detailUuid: record.punishment_discipline_uuid
									})
								}}
								style={{
									marginRight: '2px',
									padding: '2px 5px'
								}}>
									<i className="uil-align-left"></i>
							</button>
							<Tooltip
								style={{
									marginBottom: 2
								}}
								placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
								toggle={() => {
									this.setState({
										["detail" + thisId] : !this.state["detail" + thisId]
									})
								}}
							>Detail</Tooltip>
						</span>
					}

					{
					  status == -1 && this.state.isAtasan == 1 ?
						<>
							<span>
								<button
									className="btn btn-warning btn-sm"
									id={"uploadHasil-" + thisId}
									onClick={() => {
										this.setState({
											uploadHasilUuid: record.punishment_discipline_uuid
										})
									}}
									style={{
										marginRight: '2px',
										padding: '2px 5px'
									}}>
										<i className="uil-file-upload-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["uploadHasil" + thisId]} target={"uploadHasil-" + thisId}
									toggle={() => {
										this.setState({
											["uploadHasil" + thisId] : !this.state["uploadHasil" + thisId]
										})
									}}
								>Input Hasil Pemeriksaan</Tooltip>
							</span>
						</>
						: ""
					}

					{/* {
					  status == 0 && this.state.isAtasan == 1 ?
						<>
							<span>
								<button
									className="btn btn-warning btn-sm"
									id={"uploadSk-" + thisId}
									onClick={() => {
										this.setState({
											uploadSkUuid: record.punishment_discipline_uuid
										})
									}}
									style={{
										marginRight: '2px',
										padding: '2px 5px'
									}}>
										<i className="uil-file-upload-alt"></i>
								</button>
								<Tooltip
									style={{
										marginBottom: 2
									}}
									placement="top" isOpen={this.state["uploadSk" + thisId]} target={"uploadSk-" + thisId}
									toggle={() => {
										this.setState({
											["uploadSk" + thisId] : !this.state["uploadSk" + thisId]
										})
									}}
								>Upload SK</Tooltip>
							</span>
						</>
						: ""
					} */}

				</Fragment>
			);
		}
	}        
]

render() {
	return (
		<>
			<MKIDatatable
				className={this.configDatatable.tableClass}
				config={this.configDatatable}
				records={this.state.rows}
				columns={this.columns}
				dynamic={true}
				minWidth={1000}
				total_record={this.state.totalRow}
				initial={this.state.filter}
				onChange={(filter) => {
					this.setState({
						loadingTable: true,
						filter: filter
					}, function () {
						this.setTokenAPI()
					});
				}}
				loading={this.state.loadingTable}
			/>
			<ConfirmAlert
				confirmTitle="Konfirmasi!"
				confirmInfo="Apakah anda yakin akan menghapus data ini?"

				loadingTitle="Memproses data..."
				loadingInfo="Tunggu beberapa saat"

				successTitle="Berhasil!"
				successInfo="Data berhasil dihapus"

				failedTitle="Gagal!"
				failedInfo="Data gagal dihapus"

				showConfirm={this.state.confirm}
				showLoading={this.state.loading}
				showSuccess={this.state.success}
				showFailed={this.state.failed}

				response={this.confirmResponse}
			/>
			{ this.state.detailUuid !== null ?
				// <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
				<Redirect to={"/kepegawaian/hukuman_disiplin.html?detail&uuid="+ this.state.detailUuid}/>
			: null }
			{ this.state.uploadHasilUuid !== null ?
				<Redirect to={"/kepegawaian/hukuman_disiplin.html?upload_hasil&uuid="+ this.state.uploadHasilUuid}/>
			: null }
			{ this.state.uploadSkUuid !== null ?
				<Redirect to={"/kepegawaian/hukuman_disiplin.html?upload_sk&uuid="+ this.state.uploadSkUuid}/>
			: null }
		</>
    );
  }
}

export default TableSecondComponent;
